import i18next from '../../../react/features/base/i18n/i18next';

import CameraControll from '../CameraControll';
import {
    CAMERA_CONTROLL_CLASSNAME, CAMERA_CONTROLL_CONTENT_CLASSNAME,
    CAMERA_CONTROLL_HOLDER, CAMERA_CONTROLL_ICON_CLASSNAME,
    CAMERA_CONTROLL_TEXT_CLASSNAME
} from '../constants';

export default class CameraModeNotification {
    #timer = null;
    #elemWrapperIcon = document.createElement('div');

    show(data, timeout) {
        const getLocalElementbyId = document.getElementById(CAMERA_CONTROLL_HOLDER);

        this.#elemWrapperIcon.innerHTML = this.template(data);
        getLocalElementbyId.appendChild(this.#elemWrapperIcon);
        this.#elemWrapperIcon.style.display = 'block';


        if (timeout) {
            this.#timer = setTimeout(this.hide.bind(this, this.#timer), timeout);

        }
    }

    hide(timerId) {
        if (CameraControll.IS_CONTROL_ENABLED) {
            return false;
        }
        if (timerId !== this.#timer) {
            this.hide(this.#timer);
            this.#timer = timerId;

            return false;
        }
        this.#elemWrapperIcon.style.display = 'none';
        clearTimeout(this.#timer);
    }

    template(data) {
        const { title, customClass } = data;

        return `
            <div class="${CAMERA_CONTROLL_CLASSNAME} ${customClass}">
                <div class="${CAMERA_CONTROLL_CONTENT_CLASSNAME}">
                    <i class="${CAMERA_CONTROLL_ICON_CLASSNAME}"></i>
                    <div class="${CAMERA_CONTROLL_TEXT_CLASSNAME}">${i18next.t(title)}</div>
                </div>
            </div>
        `;
    }
}
